/**
 * news既読
 */
export default {
  state() {
    return {
      news: [],
      lastUpdateDate: null
    };
  },
  getters: {
    getNews(state) {
      return state.news;
    },
    getLastUpdateDate(state) {
      return state.lastUpdateDate;
    }
  },
  mutations: {
    setNews(state, list) {
      state.news = list;
    },
    setLastUpdateDate(state, updateDate) {
      state.lastUpdateDate = updateDate;
    }
  }
};
